import { getElements } from 'js-utils/src/selector';
import VimeoPlayer from '@vimeo/player';
import _ from 'underscore';
import init from '../base/init';

init(() => {

  let video = document.querySelectorAll(".video-player:not(.course-analysis-video-player)");
  if(!video.length) return;

  video = video[0];

  let activeSection = 0, sectionTimes = [];
  let currentTime = parseInt(video.getAttribute('data-video-current-time'));
  const player = document.querySelector('.video-player');
  const playVideoButtons = getElements('.play-video');
  const vimeoPlayer = new VimeoPlayer(getElements('.video-player iframe')[0]);
  const videoSections = getElements('.video-sections__inner-wrapper li');
  const mobileToggler = getElements('.video-sections__expander')[0];
  let sectionsOpen = false;
  const video_type = window.LEXNOVA.aet.props.available_to_user === "true" ? 'video' : 'trailer';
  const videoDuration = vimeoPlayer.getDuration();

  vimeoPlayer.setColor('#d61368');
  vimeoPlayer.setCurrentTime(currentTime);

  playVideoButtons.forEach( (button) => {
    button.addEventListener('click', () => {
      player.classList.add('video-player--overlay-hidden');
      vimeoPlayer.play();

      window.dispatchEvent(new CustomEvent('AET', {detail: {
        name: `${window.LEXNOVA.section_name}.${video_type}_play`,
        props: window.LEXNOVA.aet.props
      }}));
    });
  });

  vimeoPlayer.on('ended', () => {
    videoEvent({ event: 'ended', type: video_type });
    player.classList.remove('video-player--overlay-hidden');
    player.classList.remove('video-player--playing');

    window.dispatchEvent(new CustomEvent('AET', {detail: {
      name: `${window.LEXNOVA.section_name}.${video_type}_finished`,
      props: window.LEXNOVA.aet.props
    }}));
  });

  vimeoPlayer.on('play', () => {
    videoEvent({ event: 'play', type: video_type });
    player.classList.add('video-player--playing');

    window.dispatchEvent(new CustomEvent('AET', {detail: {
      name: `${window.LEXNOVA.section_name}.${video_type}_play`,
      props: window.LEXNOVA.aet.props
    }}));
  });

  vimeoPlayer.on('pause', (data) => {
    videoEvent({ event: 'pause', seconds: data.seconds, type: video_type });
    player.classList.remove('video-player--playing');

    window.dispatchEvent(new CustomEvent('AET', {detail: {
      name: `${window.LEXNOVA.section_name}.${video_type}_pause`,
      props: window.LEXNOVA.aet.props
    }}));
  });

  vimeoPlayer.on('timeupdate', (data) => {
    videoEvent({ event: 'progress', seconds: data.seconds, type: video_type });


    if (getElements('.quiz.is-hidden').length > 0) {
      // Add cue point for showing quiz at 90%
      videoDuration.then((time) => {
        if (currentTime> parseInt(time * 0.9)) {
          showQuiz();
        }
      });
    }
  });

  const fireVideoEvent = (dataObject) => {
    // User#do_not_track must be set to false
    if (video_type === 'video') {
      fetch('/api/v1/playbacks/' + video.getAttribute('data-video-resource-id'), {
        method: "PATCH",
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
        },
        body: JSON.stringify(dataObject),
      });
    }
  };

  const videoEvent = _.throttle(
    fireVideoEvent, 5.0 * 1000
  );

  const sectionProgress = () => {
    let progress = ((currentTime - sectionTimes[activeSection][0]) / (sectionTimes[activeSection][1] - sectionTimes[activeSection][0])) * 100;
    document.querySelectorAll('.video-sections__inner-wrapper li')[activeSection].firstElementChild.style.width = progress+'%';
  };

  const adjustActiveSection = () => {
    sectionTimes.map((i, index) => {
      if( currentTime > i[0] && currentTime < i[1] ){
        activeSection = index;

        videoSections.forEach((item)=>{
          item.classList.remove('active');
        });

        videoSections[activeSection].classList.add('active');
      }
    });
  };

  // if we can access full video then we also allow navigation in sections
  if( !getElements('.video-player--access-false').length > 0 ){

    if(!videoSections.length) return;

    vimeoPlayer.on('timeupdate', (data) => {
      currentTime = data.seconds;
      adjustActiveSection();
      sectionProgress();
    });

    videoSections.forEach((item) => {

      let timesArray = [];
      timesArray.push(parseInt(item.getAttribute('data-timestart')));
      timesArray.push(parseInt(item.getAttribute('data-timeend')));
      sectionTimes.push(timesArray);

      item.addEventListener('click', () => {
        currentTime = parseInt(item.getAttribute('data-timestart'));
        vimeoPlayer.setCurrentTime(currentTime);

        player.classList.add('video-player--overlay-hidden');
        vimeoPlayer.play();

        videoSections.forEach((item) => {
          item.classList.remove('active');
        });

        item.classList.add('active');

      });
    });

  }

  //sections toggle on mobile

  const videoSectionsContainer = document.querySelector('.video-sections__list-wrapper');

  const toggleSections = () => {

    if(!videoSectionsContainer.length) return;

    videoSectionsContainer.style.height = videoSectionsContainer.firstElementChild.offsetHeight + 'px';
    videoSectionsContainer.classList.toggle('open');
    mobileToggler.classList.toggle('open');

    if( sectionsOpen ) {
      window.requestAnimationFrame( () => {
        videoSectionsContainer.style.height = 0;
      });
      sectionsOpen = false;
    } else {
      sectionsOpen = true;
    }
  };

  if (videoSectionsContainer) {
    videoSectionsContainer.addEventListener('transitionend', () => {
      if( sectionsOpen ) {
        videoSectionsContainer.style.height = 'auto';
      } else {
        videoSectionsContainer.removeAttribute('style');
      }
    });
  }

  if (mobileToggler) {
    mobileToggler.addEventListener('click', () => {
      toggleSections();
    });
  }

  const showQuiz = () => {
    getElements('.quiz.is-hidden')[0].classList.remove('is-hidden');
  }
});
